















import {Component, Prop, Vue} from "vue-property-decorator";
import VisitorsIcon from '../../../assets/svg/indicators/visitors.svg';
import ViewsIcon from '../../../assets/svg/indicators/views.svg';
import CommentsIcon from '../../../assets/svg/indicators/comments.svg';
import ChatsIcon from '../../../assets/svg/indicators/chats.svg';
import MeetingsIcon from '../../../assets/svg/indicators/meetings.svg';

@Component({
    name: "AnalyticsIndicator",
    components: {
        VisitorsIcon, ViewsIcon, CommentsIcon, ChatsIcon, MeetingsIcon
    }
})
export default class AnalyticsIndicator extends Vue {
    @Prop({default: true}) withIcon: boolean;
    @Prop({required: true}) value: number;
    @Prop({default: ''}) label: string;
    @Prop() iconName: string;

    get hasLabel() {
        return !!(this.label && this.label.length > 0);
    }

    get localizationPath() {
        return `exhibition.indicators.${this.label}`
    }
}
